export const analyticsKeys = {
  analytics: ["analytics"],
  selection: ["analytics", "selection"],
};
